import { createContext } from 'react';

export const NotificationClientContext = createContext({});
